import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { UserGroup } from '@common/data-models/search-results/result-group';
import { PagerLabelFormat } from '@common/enums/enums';
import { TeamMembersActions } from '@common/store/team-members/team-members.actions';
import { selectTeamMembersCurrentGroup, selectTeamMembersTotalItemCount } from '@common/store/team-members/team-members.selectors';
import { Store } from '@ngrx/store';
import { PagerComponent } from '@src/suite/common/components/pager/pager';

@Component({
    selector: 'st-manage-team-members-right-slot',
    imports: [PagerComponent],
    templateUrl: './manage-team-members-right-slot.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-manage-team-members-right-slot',
    },
})
export class ManageTeamMembersRightSlotComponent {
    readonly PagerLabelFormat = PagerLabelFormat;

    private store = inject(Store);

    readonly pageSize = UserGroup.USERS_PER_PAGE;

    readonly totalItemCount = this.store.selectSignal(selectTeamMembersTotalItemCount);
    private currentGroup = this.store.selectSignal(selectTeamMembersCurrentGroup);

    onStartIndexChange(startIndex: number): void {
        const pageIndex = Math.floor(startIndex / this.pageSize);
        const group = this.currentGroup();
        if (group) {
            this.store.dispatch(TeamMembersActions.setCurrentPage({ group, page: pageIndex }));
        }
    }
}
